import styles from './style.module.css';
import { Column } from '@/components/SettingsLayout';
import { Text, Icon, IconType } from '@/ui';
import classNames from 'classnames';
type Icon = {
  type: IconType;
  width?: number;
};
type Props = {
  title: string;
  comment?: string;
  data?: string | number;
  icon?: Icon;
  iconFull?: boolean;
  testId?: string;
};
const GeneralCustomersCard = ({ title, comment, data, icon, iconFull, testId: _testId }: Props) => {
  const iconClass = classNames(styles.generalCustomerCard_Icon, {
    [styles.icon_full]: iconFull,
  });
  return (
    <div className={styles.generalCustomerCard}>
      <Column gapSize='8'>
        <Column gapSize='none'>
          <Text size='s' weight='medium'>
            {title}
          </Text>
          <Text size='xs' weight='light-medium' color='base-grey'>
            {comment}
          </Text>
        </Column>
        <Text size='l' weight='medium'>
          {data}
        </Text>
        {icon && (
          <div className={iconClass}>
            <Icon type={icon.type} fill='transparent' width={icon.width} />
          </div>
        )}
      </Column>
    </div>
  );
};

export default GeneralCustomersCard;
